<div class="container-fluid">
  <jhi-bary-card *ngIf="transporterMemberLinkToCustomerAccount" [title]="'MY_CONTACTS.TITLE' | translate" class="pb-3 d-block">
    <div class="card-group" body>
      <jhi-team-contact-card-visual
        [transporterMember]="transporterMemberLinkToCustomerAccount"
        [existingVisual]="profilPicPath + '/' + transporterMemberLinkToCustomerAccount.transporter?.id + '/' + transporterMemberLinkToCustomerAccount.id"
        class="m-2"
      ></jhi-team-contact-card-visual>
    </div>
  </jhi-bary-card>

  <div *ngFor="let mapTransportGroupAndMembers of mapData | keyvalue">
    <div *ngIf="mapTransportGroupAndMembers.value && mapTransportGroupAndMembers.value.length > 0" class="pb-3">
      <jhi-bary-card [title]="mapTransportGroupAndMembers.key.name! | titlecase">
        <div class="card-group" body>
          <ng-container *ngFor="let transporterMember of mapTransportGroupAndMembers.value">
            <jhi-team-contact-card-visual
              [transporterMember]="transporterMember"
              [existingVisual]="profilPicPath + '/' + transporterMember?.transporter?.id + '/' + transporterMember?.id"
              class="m-2"
            ></jhi-team-contact-card-visual>
          </ng-container>
        </div>
      </jhi-bary-card>
    </div>
  </div>

  <div class="pb-3">
    <jhi-bary-card *ngIf="memberWithoutGroups.length > 0" [title]="'MY_CONTACTS.OTHERS_SERVICES.TITLE' | translate">
      <div class="card-group" body>
        <ng-container *ngFor="let transporterMember of memberWithoutGroups">
          <jhi-team-contact-card-visual
            [transporterMember]="transporterMember"
            [existingVisual]="profilPicPath + '/' + transporterMember?.transporter?.id + '/' + transporterMember?.id"
            class="m-2"
          ></jhi-team-contact-card-visual>
        </ng-container>
      </div>
    </jhi-bary-card>
  </div>
</div>
